import { IPreloadedState } from 'shared/types/redux';

export const selectTags = (state: IPreloadedState) => state.tags.items;
